import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

export const adminGuard: CanActivateFn = async (route, state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (!sessionService.isSessionLoaded()) {
    try {
      await firstValueFrom(
        sessionService.checkSessionStatus().pipe(timeout(5000))
      );
    } catch {
      router.navigate(['/']);
      return false;
    }
  }

  if (sessionService.isAdmin()) {
    return true;
  }

  router.navigate(['/unauthorized']);
  return false;
};
